import { render, staticRenderFns } from "./IconAssessmentForm.vue?vue&type=template&id=e002b1be"
import script from "./IconAssessmentForm.vue?vue&type=script&lang=js"
export * from "./IconAssessmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports